/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import Box from '../Box';

import { SALE_TYPE } from '../../../../constants';
import Product from '../../Product';
import styles from './styles.module.scss';

const Products = ({ products }) => (
  <>
    {products.map((product, index) => {
      const { productType, items = [] } = product;
      if (productType === 'box') {
        return (<Box key={index} box={product} />);
      }

      return (
        <div key={productType} className={styles.program}>
          {products.length > 1 && (
            <h2>{SALE_TYPE[productType]}</h2>
          )}
          <ul>
            {items.map(({
              name, brandName, priceInCents, quantity, imageUrl, autoAssigned, slug,
            }, itemIndex) => (
              <Product
                key={itemIndex}
                name={name}
                brandName={brandName}
                price={priceInCents / 100}
                quantity={quantity}
                imageUrl={imageUrl}
                autoAssigned={autoAssigned}
                slug={slug}
              />
            ))}
          </ul>
        </div>
      );
    })}
  </>
);

Products.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default Products;
